import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/hooks/useAuth";
import {
  opsReviewHomePath,
  resolvePreFlightScriptsAccess,
} from "@/features/auth/lib/assert-pre-flight-scripts-access";
import { ScriptReviewHubPage } from "@/features/script-review/pages/ScriptReviewHubPage";

export const Route = createFileRoute("/_authenticated/pre-flight-scripts/")({
  beforeLoad: () => {
    const home = opsReviewHomePath(
      resolvePreFlightScriptsAccess(
        useAuth.getState().tenants,
        useAuth.getState().activeTenantId,
      ),
    );
    if (home) throw redirect({ to: home });
  },
  component: ScriptReviewHubRoute,
});

function ScriptReviewHubRoute() {
  const navigate = useNavigate();
  return (
    <ScriptReviewHubPage
      onOpenReview={(reviewId) =>
        void navigate({
          to: "/pre-flight-scripts/review/$reviewId",
          params: { reviewId },
        })
      }
    />
  );
}
